!function($) {
  const selectors = {
    qntSelect: '[data-qnt-select]',
    variantSelect: '[data-variant-select]',
    productTabs: '[data-product-tabs]',
  }
  // Add custom JavasScript here
  // --------------------------
  $("#timer").css( "opacity", "0" );
  var dropDate = $("#timer").data("time");
  var countDownDate = new Date(dropDate + '  GMT-0400').getTime();

  var x = setInterval(function() {

    var now = new Date().getTime();
    var distance = countDownDate - now;

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    var html = document.getElementById("timer")

    if (html) {
      html.innerHTML = days + " Days | " + hours + " Hours | "
      + minutes + " Minutes | " + seconds + " Seconds";
    }

    if (distance < 0) {
      clearInterval(x);

      if (html) {
      	document.getElementById("timer").innerHTML = "0 Days | 0 Hours | 0 Minutes | 0 Seconds";
      }
    }
  }, 1000);


  // Document ready
  $(function() {
    $( "#timer" ).animate({
      opacity: 1,
    }, 1300, function() {
      // Animation complete.
    });

  });

    //helpers
    function documentLockScroll() {
        $('body').toggleClass('stop-scrolling');
    }

    window.sameHeight = function(selector) {
        var maxHeight = 0;

        $(selector).each(function(){
            if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
        });

        $(selector).height(maxHeight);
    }
    //

    //header new
    const windowWidth = window.outerWidth;
    const searchContainer = $('[data-search-container]');
    const searchBtn = $('[data-search-btn]');
    const searchInput = $('[data-search-input]');
    const mobileMenu = $('.nav-mobile');
    const mobileMenuBtn = $('[data-mobile-menu-btn]');
    const logoMobile = $('.logo--mobile');

    searchBtn.on('click', function () {
        $(this).closest('.search').toggleClass('active');
        searchInput.trigger('focus');

        if (windowWidth < 768) {
            logoMobile.css('display', 'none')
            $('.header-wrapper').css('min-height', '56px')
        }
    });
    searchInput.on('blur', function () {
        searchContainer.removeClass('active');
        if (windowWidth < 768) {
            logoMobile.css('display', 'block')

        }
    });

    mobileMenuBtn.on('click', function () {
        $(this).toggleClass('is-open');
        mobileMenu.toggleClass('nav-mobile--is-open');
        documentLockScroll();
    });

    // homepage build your pack
    var packBlock = $('.build-your-pack-form_inner__block')
    var packBtn = $('.build-your-pack-form_inner__button a')

    packBlock.click(function() {
      packBlock.removeClass('active')
      $(this).addClass('active')

      var newHref = packBtn.attr('href').split('?')[0] + '?' + $(this).data('pack') + '-pack'
      packBtn.attr('href', newHref)

      var packPrice = $(this).data('price')
      $('.build-your-pack-form_inner__button a span').text(packPrice)
    })


    // build your pack template
    var bypBlock = $('.byp__block')
    var bypAddToCart = $('.byp__btn .btn')
    var bypJar = $('.byp__jar')
    var bypPlus = $('.byp__collections-product .byp__collections-product-plus')
    var bypMinus = $('.byp__collections-product .byp__collections-product-minus')

    bypBlock.click(function() {
      if (!$(this).hasClass('active')) {
        // remove selected products
        clearSelections(false)

        bypBlock.removeClass('active')
        $(this).addClass('active')

        var quantity = $(this).data('title').replace(/[^0-9]/gi, '')
        window.history.replaceState(null, null, `?${quantity}-pack`)

        $('.byp__jar').remove()

        var html = '<div class="byp__jar"><div class="byp__jar-top"></div><div class="byp__jar-body"></div></div>'

        for (let i = 0; i < quantity; i++) {
          $('.byp__jars').append(html)
        }

        $('.byp__jar').not('.filled').length ? $('.byp__btn .btn').addClass('disabled') : $('.byp__btn .btn').removeClass('disabled')
        $('.byp__jar').not('.filled').length ? $('.pack-mobile-btn').addClass('hidden') : $('.pack-mobile-btn').removeClass('hidden')

      }
    })

    bypPlus.click(function() {

      if ($('.byp__jar').not('.filled').length) {
        var emptyJar = $('.byp__jar').not('.filled').eq(0)
        var selectedProduct = $(this).closest('.byp__collections-product')
        var selectedTitle = $(this).closest('.byp__collections-product').data('title')
        var selectedId = $(this).closest('.byp__collections-product').data('id')
        var removeJar = '<span class="byp_jar-remove">-</span>'
        var jarTitle = `<span class="byp_jar-title">${selectedTitle}</span>`

        emptyJar.append(removeJar, jarTitle)

        emptyJar.attr('data-title', selectedTitle)
        emptyJar.attr('data-id', selectedId)
        emptyJar.addClass('filled')

        var productBg = '<div class="byp__collections-product-bg"><span class="byp__collections-product-counter"></span></div>'

        if (selectedProduct.find('.byp__collections-product-bg').length) {
          var counter = parseInt(selectedProduct.data('counter'))
          counter++
          selectedProduct.find('.byp__collections-product-counter').html(`${counter} </br> added to box`)
          selectedProduct.data('counter', counter)
        } else {
          selectedProduct.addClass('selected')
          selectedProduct.append(productBg)
          selectedProduct.find('.byp__collections-product-counter').html('1 </br> added to box')
          selectedProduct.attr('data-counter', '1')
        }

        $('.byp__jar').not('.filled').length ? $('.byp__btn .btn').addClass('disabled') : $('.byp__btn .btn').removeClass('disabled')
        $('.byp__jar').not('.filled').length ? $('.pack-mobile-btn').addClass('hidden') : $('.pack-mobile-btn').removeClass('hidden')
      }

    })

    bypMinus.click(function() {
      if ($(this).closest('.byp__collections-product').data('counter')) {
        var selectedProduct = $(this).closest('.byp__collections-product')
        var selectedId = $(this).closest('.byp__collections-product').data('id')
        var counter = parseInt(selectedProduct.data('counter'))

        // change added product quantity
        if (counter > 1) {
          counter--
          selectedProduct.find('.byp__collections-product-counter').html(`${counter} </br> added to box`)
          selectedProduct.data('counter', counter)
        } else {
          selectedProduct.removeClass('selected')
          selectedProduct.removeAttr('data-counter')
          selectedProduct.find('.byp__collections-product-bg').remove()
        }

        // remove Jar
        var selectedJar = $(`.byp__jar.filled[data-id="${selectedId}"]`).last()
        selectedJar.removeClass('filled')
        selectedJar.find('.byp_jar-remove').remove()
        selectedJar.find('.byp_jar-title').remove()
        $('.byp__jars').append(selectedJar)

        $('.byp__jar').not('.filled').length ? $('.byp__btn .btn').addClass('disabled') : $('.byp__btn .btn').removeClass('disabled')
        $('.byp__jar').not('.filled').length ? $('.pack-mobile-btn').addClass('hidden') : $('.pack-mobile-btn').removeClass('hidden')
      }
    })

    $(document).click(function(e) {
      if($(e.target).hasClass('byp_jar-remove')){
        var selectedJar = $(e.target).closest('.byp__jar')
        var id = selectedJar.data('id')
        var selectedProduct = $(`.byp__collections-product[data-id="${id}"]`)

        if (selectedProduct.data('counter') > 1) {
          var counter = parseInt(selectedProduct.data('counter'))
          counter--
          selectedProduct.find('.byp__collections-product-counter').html(`${counter} </br> added to box`)
          selectedProduct.data('counter', counter)
        } else {
          selectedProduct.removeClass('selected')
          selectedProduct.removeAttr('data-counter')
          selectedProduct.find('.byp__collections-product-bg').remove()
        }
        selectedJar.removeClass('filled')
        selectedJar.find('.byp_jar-remove').remove()
        selectedJar.find('.byp_jar-title').remove()
        $('.byp__jars').append(selectedJar)

        $('.byp__jar').not('.filled').length ? $('.byp__btn .btn').addClass('disabled') : $('.byp__btn .btn').removeClass('disabled')
        $('.byp__jar').not('.filled').length ? $('.pack-mobile-btn').addClass('hidden') : $('.pack-mobile-btn').removeClass('hidden')
      }
    })

    $('.byp__collections-block').click(function() {
      var handle = $(this).data('handle')
      // $(document).scrollTo(`.byp__collections-products-wrap[data-handle="${handle}"]`)
      $(`.byp__collections-products-title[data-handle="${handle}"]`).get(0).scrollIntoView()
    })

    bypAddToCart.click(function() {
      var time = (new Date()).getTime()
      var filled = $('.byp__jar.filled')

      if (!$('.byp__jar').not('.filled').length) {
        var items = []
        var data = []

        $('.byp__jar.filled').each(function() {
          var title = $(this).data('title')
          items.push(title)
        })

        data.push({
          id: $('.byp__block.active').data('id'),
          quantity: 1,
          properties: {
            bundleId: time,
            bundleItems: items
          }
        })

        filled.each(function() {
          var id = $(this).data('id')

          if (data.length) {
            if(data.some( obj => obj.id === id )) {
              let obj = data.find((o) => {
                return o.id === id;
              });

              obj.quantity += 1

              return
            }

            data.push({
              id: id,
              quantity: 1,
              properties: {
                isBundleProduct: true,
                bundleId: time
              }
            })

          } else {
            data.push({
              id: id,
              quantity: 1,
              properties: {
                isBundleProduct: true,
                bundleId: time
              }
            })
          }

        })

        let formData = {
          'items': data
         };

         fetch('/cart/add.js', {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json'
           },
           body: JSON.stringify(formData)
         })
         .then(response => {
           window.fetchCart()
           $('#ajax-cart').addClass('active')
           clearSelections(true)
           $('body').css('overflow', 'hidden')
         })
         .catch((error) => {
           console.error('Error:', error);
         });

      }

    })


    function clearSelections(bool) {
      var quantity = ($('.byp__jar').length)
      $('.byp__collections-product').removeClass('selected')
      $('.byp__collections-product').data('counter', 1)
      $('.byp__collections-product').removeAttr('data-counter')
      $('.byp__collections-product-bg').remove()
      $('.byp__btn .btn').addClass('disabled')
      $('.pack-mobile-btn').addClass('hidden')


      if (bool) {
        $('.byp__jar').remove()

        var html = '<div class="byp__jar"><div class="byp__jar-top"></div><div class="byp__jar-body"></div></div>'

        for (let i = 0; i < quantity; i++) {
          $('.byp__jars').append(html)
        }
      }
    }

    function initVariantSelects() {
      const container = $(selectors.variantSelect);
      if (container.length === 0) {
        return;
      }
      else {
        container.each(function () {
          const _this = $(this);
          const $selectLabel = _this.find('.variant-select__label');
          const $selectDropdown = _this.find('.variant-select__dropdown');
          const $dropDownElements = $selectDropdown.find('span').not('.disabled');

          $selectLabel.click(function (e){
            $selectDropdown.toggleClass('active');
          });

          $dropDownElements.click(function () {
            const title = $(this).data('title');

            $dropDownElements.removeClass('active');
            $(this).addClass('active');
            _this.data('title', title);
            $selectLabel.find('.variant-title').text(title);
            $selectDropdown.removeClass('active');
          })
        });
      }

    }
    function initQntSelects() {
      const container = $(selectors.qntSelect);
      if (container.length === 0) {
        return;
      }
      else {
        container.each(function () {
          const _this = $(this);
          const $selectLabel = _this.find('.qnt-select__label');
          const $selectDropdown = _this.find('.qnt-select__dropdown');
          const $dropDownElements = $selectDropdown.find('span');

          $selectLabel.click(function (e){
            $selectDropdown.toggleClass('active');
          });

          $dropDownElements.click(function () {
            const qnt = $(this).data('qnt');

            $dropDownElements.removeClass('active');
            $(this).addClass('active');
            _this.data('qnt', qnt);
            $selectLabel.find('.num').text(qnt);
            $selectDropdown.removeClass('active');
          })
        });
      }

    }

    function initProductTabs() {
      const container = $(selectors.productTabs);
      if (container.length === 0) {
        return;
      }
      else {
        container.each(function () {
          const _this = $(this);
          const $labels = _this.find('.label');
          const $tabsContentContainer = _this.find('.pdp-tabs__content');

          $labels.click(function () {
            const content = $(this).data('tab-content');

            $labels.not($(this)).removeClass('label--active');
            $(this).toggleClass('label--active');
            $tabsContentContainer.html(`<pre>${content}</pre>`);

            if (!$('.label--active').length) {
              $tabsContentContainer.empty();
            }
          });
        });
      }
    }

    initQntSelects();
    initVariantSelects();
    initProductTabs();

    window.addEventListener('load', () => {
      const links = document.querySelectorAll('[href="javascript:void(0)"]');

      links.forEach(link => {
        link.setAttribute('href', '#');
      });

      $(".text-m").click(function() {
        $('html, body').animate({
            scrollTop: $("#yotpo").offset().top
        }, 1000);
      });
    });

    $('.p-select').click(function() {
      $(this).find('.p-select__list').slideToggle();
      $(this).toggleClass('active');
    })

  $('.p-select__item').click(function() {
    let name = $(this).attr('data-name');
    let id = $(this).attr('data-id');
    $('.p-select__label span').text(name);
    $(`.swatch-item[data-id="${id}"]`).click();
    setTimeout(() => {
      $('.p-select__item').show();
      $(this).hide();
    }, 200)
  })


}(jQuery);



